import { apiUrl } from "./api";

const getId = (key) => {
  const existing =
    window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
  if (existing) return existing;

  const id =
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  if (key.includes("session")) {
    window.sessionStorage.setItem(key, id);
  } else {
    window.localStorage.setItem(key, id);
  }

  return id;
};

export const getAnalyticsIds = () => ({
  visitorId: getId("krrish_analytics_visitor_id"),
  sessionId: getId("krrish_analytics_session_id"),
});

export const trackAnalyticsEvent = (eventType, payload = {}) => {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (window.location.pathname.startsWith("/admin")) return Promise.resolve(false);

  const body = JSON.stringify({
    eventType,
    ...getAnalyticsIds(),
    path: window.location.pathname + window.location.search,
    referrer: document.referrer,
    ...payload,
  });

  const url = apiUrl("/analytics/events");

  // Use fetch + keepalive instead of sendBeacon.
  // sendBeacon ignores the Content-Type on the Blob in many browsers and
  // sends text/plain, so Express body-parser never parses the body and
  // every event silently fails with a 400. fetch+keepalive survives page
  // navigation just as well and always sends the correct Content-Type.
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  })
    .then((res) => {
      if (process.env.NODE_ENV !== "production") {
        console.log(
          `[analytics] ${eventType}: ${res.ok ? "saved" : "failed (status " + res.status + ")"}`,
          { url }
        );
      }
      return res.ok;
    })
    .catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        console.warn(`[analytics] ${eventType}: request failed`, err);
      }
      return false;
    });
};